import { lazy } from "react";

const SurmountAccountCreate = lazy(() =>
  import("features/SurmountAccount/CreateAccountForm")
);
const SurmountAccount = lazy(() => import("features/SurmountAccount"));

export const SURMOUNT_ACCOUNT_PATH = "/dashboard/surmount-account";
export const SURMOUNT_ACCOUNT_CREATE_PATH =
  "/dashboard/surmount-account/create";

export const surmountAccountRoutes = [
  {
    path: SURMOUNT_ACCOUNT_CREATE_PATH,
    component: <SurmountAccountCreate />,
  },
  {
    path: SURMOUNT_ACCOUNT_PATH,
    component: <SurmountAccount />,
  },
];
